var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9892 2.72594C21.9801 2.65406 21.9642 2.5849 21.938 2.52C21.9371 2.51844 21.9371 2.51615 21.9367 2.51411C21.9367 2.5137 21.9363 2.51328 21.9359 2.51292C21.907 2.44453 21.8676 2.3825 21.823 2.3249C21.812 2.3113 21.8012 2.29781 21.7896 2.28505C21.742 2.2313 21.6904 2.18167 21.6303 2.1412C21.6287 2.13995 21.6267 2.13958 21.6251 2.13833C21.567 2.1001 21.503 2.0712 21.4358 2.04844C21.4192 2.0425 21.4029 2.03745 21.3858 2.03297C21.3154 2.01385 21.243 2 21.1667 2H15.3333C14.8733 2 14.5 2.37333 14.5 2.83333C14.5 3.29333 14.8733 3.66667 15.3333 3.66667H19.1545L14.1808 8.64042C12.8545 7.57969 11.2216 7 9.5 7C5.36469 7 2 10.3647 2 14.5C2 18.6353 5.36469 22 9.5 22C13.6353 22 17 18.6353 17 14.5C17 12.7792 16.4208 11.1467 15.3592 9.81922L20.3333 4.84505V8.66667C20.3333 9.12667 20.7067 9.5 21.1667 9.5C21.6267 9.5 22 9.12667 22 8.66667V2.83333C22 2.81583 21.9959 2.79917 21.9949 2.78208C21.9936 2.76329 21.9917 2.7446 21.9892 2.72594ZM9.5 20.3333C6.28323 20.3333 3.66667 17.7168 3.66667 14.5C3.66667 11.2832 6.28323 8.66667 9.5 8.66667C11.0574 8.66667 12.5237 9.27292 13.6262 10.3716C14.727 11.4763 15.3333 12.9426 15.3333 14.5C15.3333 17.7168 12.7168 20.3333 9.5 20.3333Z",
    fill: "#17181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male_icon.ce37fecf3bb438e11682ca4c6ebdec7e.svg";
export { ForwardRef as ReactComponent };